import { PixelBuffer } from "../pixel/PixelBuffer";
import type { Selection } from "../selection/Selection";
import type { Filter } from "./Filter";

export interface FacetParams {
  radius: number;
}

function clamp8(v: number): number {
  return v < 0 ? 0 : v > 255 ? 255 : v;
}

export const Facet: Filter<FacetParams> = {
  id: "facet",
  displayName: "Facet",
  defaultParams: { radius: 8 },

  apply(input: PixelBuffer, params: FacetParams, _selection: Selection | null): PixelBuffer {
    const w = input.width;
    const h = input.height;
    const out = new PixelBuffer(w, h, input.mode);
    const src = input.data;
    const dst = out.data;

    if (w === 0 || h === 0) { dst.set(src); return out; }

    const size = Math.max(2, Math.round(params.radius));

    for (let cy = 0; cy < h; cy += size) {
      for (let cx = 0; cx < w; cx += size) {
        let sumR = 0, sumG = 0, sumB = 0, sumA = 0, count = 0;
        const endY = Math.min(cy + size, h);
        const endX = Math.min(cx + size, w);

        for (let y = cy; y < endY; y++) {
          for (let x = cx; x < endX; x++) {
            const si = (y * w + x) * 4;
            sumR += src[si]!; sumG += src[si + 1]!; sumB += src[si + 2]!; sumA += src[si + 3]!;
            count++;
          }
        }

        const avgR = Math.round(sumR / count);
        const avgG = Math.round(sumG / count);
        const avgB = Math.round(sumB / count);
        const avgA = Math.round(sumA / count);

        for (let y = cy; y < endY; y++) {
          for (let x = cx; x < endX; x++) {
            const o = (y * w + x) * 4;
            dst[o] = avgR; dst[o + 1] = avgG; dst[o + 2] = avgB; dst[o + 3] = avgA;
          }
        }
      }
    }
    return out;
  },
};
